(() => {
'use strict';
document.documentElement.classList.add('js');
const cfg = JSON.parse(document.getElementById('kt-config')?.textContent || '{}');
const t = cfg.strings || {};
function initializeHome(scope = document) {
 const root = scope.querySelector('#kk-home') || (scope.id === 'kk-home' ? scope : null);
 if (!root || root.dataset.initialized) return;
 root.dataset.initialized = 'true';
 const track = root.querySelector('.kk-brandtrack');
 const brands = root.querySelector('.kk-brands');
 const pause = root.querySelector('#kk-brandpause');
 if (track && brands && pause) {
  const copy = track.querySelector('.kk-brandgroup').cloneNode(true);
  copy.setAttribute('aria-hidden','true'); copy.inert = true;
  copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
  track.appendChild(copy);
  pause.addEventListener('click', () => {
   const paused = brands.classList.toggle('kk-paused');
   pause.setAttribute('aria-pressed', String(paused));
   pause.setAttribute('aria-label', paused ? t.play_label : t.pause_label);
   pause.textContent = paused ? t.play : t.pause;
  });
 }
 const looks = root.querySelector('#kk-looktrack');
 if (!looks) return;
 const slides = [...looks.querySelectorAll('.kk-lookslide')];
 const prev = root.querySelector('.kk-lookprev'), next = root.querySelector('.kk-looknext');
 const status = root.querySelector('#kk-lookstatus');
 const geometry = () => { const step = slides[0].getBoundingClientRect().width + 18; return {step,visible:Math.max(1,Math.round((looks.clientWidth+18)/step)),index:Math.round(looks.scrollLeft/step)}; };
 const update = () => {const {visible,index}=geometry();prev.disabled=looks.scrollLeft<2;next.disabled=looks.scrollLeft>=looks.scrollWidth-looks.clientWidth-2;status.textContent=(t.look_status||'').replace('{first}',index+1).replace('{last}',Math.min(slides.length,index+visible)).replace('{total}',slides.length);};
 const move = d => {const {step,visible,index}=geometry();looks.scrollTo({left:Math.max(0,Math.min(slides.length-visible,index+d*visible))*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
 looks.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(looks);update();
}
initializeHome();document.addEventListener('shopify:section:load', e => initializeHome(e.target));
document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{
 const option=select.selectedOptions[0], root=select.closest('[data-product-section]');
 const button=root.querySelector('[data-add-button]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?t.sold:t.add;
 root.querySelector('[data-product-price]').textContent=option.dataset.price;
 const compare=root.querySelector('[data-product-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;
 const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url.pathname+url.search);
}));
const dialog=document.getElementById('kt-quickview');
let quickProduct=null,photoIndex=0,trigger=null,controller=null;
const q=s=>dialog.querySelector(s);
const money=cents=>new Intl.NumberFormat(cfg.locale||'en-US',{style:'currency',currency:cfg.currency||'USD'}).format(cents/100);
function renderPhoto(){
 const images=quickProduct?.images||[];const img=q('#kt-quick-image');
 img.hidden=!images.length;if(images.length){img.src=images[photoIndex];img.alt=quickProduct.title;}
 q('[data-photo-count]').textContent=images.length?`${photoIndex+1} / ${images.length}`:'';
 q('[data-photo-prev]').disabled=images.length<2;q('[data-photo-next]').disabled=images.length<2;
}
document.addEventListener('click',async e=>{
 const button=e.target.closest('[data-quick-view]');if(!button||!dialog)return;
 trigger=button;controller?.abort();controller=new AbortController();
 const thisController=controller;
 q('[data-quick-status]').textContent=t.loading;q('[data-quick-content]').hidden=true;
 q('#kt-quick-title').textContent=button.closest('article').querySelector('.kc-name').textContent;
 dialog.showModal();document.body.classList.add('kt-modal-open');q('[data-quick-close]').focus();
 try{
  const url=new URL(button.dataset.quickView,location.origin);url.pathname=url.pathname.replace(/\/$/,'')+'.js';
  const response=await fetch(url.pathname+url.search,{signal:thisController.signal,headers:{Accept:'application/json'}});
  if(!response.ok)throw new Error('Product preview unavailable');
  const product=await response.json();if(thisController!==controller)return;
  quickProduct=product;photoIndex=0;
  q('#kt-quick-title').textContent=product.title;q('[data-quick-vendor]').textContent=product.vendor;
  q('[data-quick-price]').textContent=money(product.price);q('[data-quick-availability]').textContent=product.available?t.available:t.sold;
  q('[data-quick-link]').href=button.dataset.quickView;renderPhoto();
  q('[data-quick-status]').textContent='';q('[data-quick-content]').hidden=false;
 }catch(error){
  if(error.name==='AbortError')return;
  q('[data-quick-status]').textContent=t.error;
  const link=document.createElement('a');link.href=button.dataset.quickView;link.textContent=q('[data-quick-link]').textContent;link.className='kt-button';q('[data-quick-status]').append(document.createElement('br'),link);
 }
});
q('[data-quick-close]')?.addEventListener('click',()=>dialog.close());
dialog?.addEventListener('click',e=>{if(e.target===dialog){const box=dialog.getBoundingClientRect();if(e.clientX<box.left||e.clientX>box.right||e.clientY<box.top||e.clientY>box.bottom)dialog.close();}});
dialog?.addEventListener('close',()=>{controller?.abort();document.body.classList.remove('kt-modal-open');trigger?.focus();});
q('[data-photo-prev]')?.addEventListener('click',()=>{photoIndex=(photoIndex+quickProduct.images.length-1)%quickProduct.images.length;renderPhoto();});
q('[data-photo-next]')?.addEventListener('click',()=>{photoIndex=(photoIndex+1)%quickProduct.images.length;renderPhoto();});
})();
